export const parsePositiveNumber = (
  value: number | string | null | undefined
) => {
  const parsedValue = Number(value);
  return parsedValue > 0 ? parsedValue : 0;
};
